export interface MediaPlatformAccount {
  id: string
  accountId: number,
  createdByUserProfileId: number,
  platform: MediaPlatformType,
  displayName: string,
  username: string,
  status: MediaPlatformStatus,
  createdDateTime: string // '2026-05-06T10:00:00Z',
  updatedDateTime: string // '2026-05-06T10:10:00Z',
  disconnectedDateTime: string // '2026-05-06T10:15:00Z'
}

export enum MediaPlatformStatus {
  'PENDING' = 'PENDING',
  'CONNECTED' = 'CONNECTED',
  'DISCONNECTED' = 'DISCONNECTED',
  'FAILED' = 'FAILED',
}

export enum MediaPlatformType {
  'FACEBOOK' = 'FACEBOOK',
  'INSTAGRAM' = 'INSTAGRAM',
  'X' = 'X',
  'LINKEDIN' = 'LINKEDIN',
}

export enum TargetPlatformType {
  'GBP_LOCAL_POST' = 'GBP_LOCAL_POST',
  'FACEBOOK' = 'FACEBOOK',
  'INSTAGRAM' = 'INSTAGRAM',
  'X' = 'X',
  'LINKEDIN' = 'LINKEDIN',
}